(function ($) {
  $.fn.holdToConfirm = function (options) {
    const settings = $.extend(
      {
        targetSelector: null,
        svgSelector: '.ring-svg',
        totalDuration: 2000,
        holdDelay: 250,
        ringRadius: 8,
        ringPadding: 2,
        ringColor: null,
        shadowColor: null,
        onComplete: function ($wrapper, $target) {},
        onCancel: function ($wrapper, $target) {},
        onStep: function ($wrapper, progress) {},
        onStart: function ($wrapper) {},
      },
      options
    );

    return this.each(function () {
      const $wrap = $(this);
      const $target = settings.targetSelector
        ? $wrap.find(settings.targetSelector)
        : $wrap;
      const $svg = $wrap.find(settings.svgSelector);

      // --- FIX 1: Allow browser panning via CSS ---
      $target.css('touch-action', 'pan-y pan-x');

      let ringColor = settings.ringColor;
      let shadowColor = settings.shadowColor;

      if (!ringColor || !shadowColor) {
        const bgColor =
          $target.css('background-color') || $target.css('background');
        ringColor = ringColor || '#ffffff';
        shadowColor = shadowColor || 'rgba(0,0,0,0.35)';

        if (bgColor) {
          const rgbMatch = bgColor.match(/\d+/g);
          if (rgbMatch && rgbMatch.length >= 3) {
            const r = parseInt(rgbMatch[0], 10);
            const g = parseInt(rgbMatch[1], 10);
            const b = parseInt(rgbMatch[2], 10);
            const yiq = (r * 299 + g * 587 + b * 114) / 1000;
            if (yiq >= 128) {
              ringColor = settings.ringColor || '#111111';
              shadowColor = settings.shadowColor || 'rgba(255, 255, 255, 0.6)';
            }
          }
        }
      }

      let anim = null;
      let going = false;
      let currentPerim = 0;
      let resetTimeout = null;
      let intentTimeout = null;
      let intentFired = false;
      let touchStartPos = { x: 0, y: 0 }; // Track starting position

      function createRing() {
        const rect = $target[0].getBoundingClientRect();
        const w = rect.width + settings.ringPadding;
        const h = rect.height + settings.ringPadding;
        $svg.attr({ width: w + 2, height: h + 2 });

        const x = 4,
          y = 4,
          width = w - 2,
          height = h - 2,
          r = settings.ringRadius;
        currentPerim =
          2 * (width - 2 * r) + 2 * (height - 2 * r) + 2 * Math.PI * r;
        const startOffset = -((width - 2 * r) / 2);

        $svg.html(`
          <rect class="r-track" x="${x}" y="${y}" width="${width}" height="${height}" rx="${r}" fill="none" stroke="${ringColor}" stroke-width="3" style="opacity: 0;"/>
          <rect class="r-shadow" x="${x}" y="${y}" width="${width}" height="${height}" rx="${r}" fill="none" stroke="${shadowColor}" stroke-width="5.5" stroke-linecap="round" stroke-dasharray="0 ${currentPerim}" stroke-dashoffset="${startOffset}" style="opacity: 0;"/>
          <rect class="r-prog" x="${x}" y="${y}" width="${width}" height="${height}" rx="${r}" fill="none" stroke="${ringColor}" stroke-width="3" stroke-linecap="round" stroke-dasharray="0 ${currentPerim}" stroke-dashoffset="${startOffset}" style="opacity: 0;"/>
        `);
        return startOffset;
      }

      let initialOffset = createRing();
      const resizeObserver = new ResizeObserver(() => {
        if (!going) initialOffset = createRing();
      });
      resizeObserver.observe($target[0]);

      // Swallow the click the browser fires on release of a long press.
      // Touch devices often fire no click after a long press, so the guard
      // expires instead of swallowing the user's next real tap.
      function suppressNextClick() {
        function stopClick(e) {
          e.stopImmediatePropagation();
          e.preventDefault();
          $target[0].removeEventListener('click', stopClick, true);
        }
        $target[0].addEventListener('click', stopClick, true);
        setTimeout(function () {
          $target[0].removeEventListener('click', stopClick, true);
        }, 600);
      }

      function reset() {
        $svg.find('.r-track').css('opacity', 0);
        $svg
          .find('.r-prog, .r-shadow')
          .attr('stroke-dasharray', `0 ${currentPerim}`)
          .attr('stroke-dashoffset', initialOffset)
          .css('opacity', 0);
      }

      function start() {
        if (going) return;
        going = true;
        intentFired = false;
        if (resetTimeout) clearTimeout(resetTimeout);

        intentTimeout = setTimeout(() => {
          intentFired = true;
          initialOffset = createRing();
          $svg.find('.r-track').css('opacity', 0.13);
          $svg.find('.r-prog, .r-shadow').css('opacity', 1);

          anim = { v: 0 };
          $(anim).animate(
            { v: currentPerim },
            {
              duration: settings.totalDuration - settings.holdDelay,
              easing: 'linear',
              step: function (val) {
                val = Math.max(0, Math.min(val, currentPerim));
                const remain = currentPerim - val;
                $svg
                  .find('.r-prog, .r-shadow')
                  .attr('stroke-dasharray', `${val} ${remain}`);
                settings.onStep($wrap, val);
              },
              complete: function () {
                going = false;
                anim = null;
                $target.data('holdCompletedAt', Date.now());
                suppressNextClick();
                resetTimeout = setTimeout(reset, 700);
                settings.onComplete($wrap, $target);
              },
            }
          );
          settings.onStart($wrap, $target);
        }, settings.holdDelay);
      }

      function cancel() {
        if (!going) return;
        going = false;
        if (intentTimeout) clearTimeout(intentTimeout);
        if (anim) {
          $(anim).stop(true);
          anim = null;
        }
        reset();
        if (intentFired) {
          suppressNextClick();
          settings.onCancel($wrap, $target);
        }
        intentFired = false;
      }

      // --- FIX 2 & 3: Native Passive Listeners & Move Threshold ---
      const el = $target[0];

      // Handle Mouse
      $target.on('mousedown', function (e) {
        // Only prevent default for mouse to stop text selection,
        // but avoid doing this on touch to allow scrolling.
        if (e.type === 'mousedown') start();
      });

      // Handle Touch Start (Passive)
      el.addEventListener(
        'touchstart',
        (e) => {
          const touch = e.touches[0];
          touchStartPos = { x: touch.clientX, y: touch.clientY };
          start();
        },
        { passive: true }
      );

      // Handle Touch Move (Passive + Threshold)
      el.addEventListener(
        'touchmove',
        (e) => {
          if (!going) return;
          const touch = e.touches[0];
          const dx = touch.clientX - touchStartPos.x;
          const dy = touch.clientY - touchStartPos.y;
          const distance = Math.sqrt(dx * dx + dy * dy);

          // If moved more than 10px, assume they are scrolling or swiping
          if (distance > 10) {
            cancel();
          }
        },
        { passive: true }
      );

      // Handle Ends
      $target.on('mouseup mouseleave touchend touchcancel', function () {
        if (going) cancel();
      });
    });
  };
})(jQuery);
